import { fallbackRestUrl } from "./path";

const API_URL = process.env.REST_URL || fallbackRestUrl;

export interface StoryCreationCheckResult {
  canCreate: boolean;
  reason?: string;
  currentStoryCount?: number;
  maxStories?: number;
  orderId?: string;
  orderType?: string;
}

export const checkStoryCreationLimit = async (
  userId: string,
  token: string
): Promise<StoryCreationCheckResult> => {
  try {
    const response = await fetch(`${API_URL}/stories/check-can-create/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Failed to check story creation limit:", error);
    // Default to allowing creation if check fails (fail open)
    return { canCreate: true };
  }
};
